async function copyURL() {
    try {
        const url = window.location.href;
        await navigator.clipboard.writeText(url);

        // Show the notification
        const notification = document.getElementById('copy-notification');
        notification.style.visibility = 'visible';
        notification.style.opacity = '1';

        // Hide the notification after 3 seconds
        setTimeout(() => {
            notification.style.opacity = '0';
        }, 3000);
    } catch (err) {
        console.error('Failed to copy: ', err);
    }
}

export default function copyURLforSharing() {
    const copyLink = document.getElementById('share--link');
    if (copyLink) {
        copyLink.addEventListener('click', (event) => {
            event.preventDefault();
            console.log('Copy link clicked')
            copyURL();
        });
    }
}